import { useQuery } from '@tanstack/react-query';
import { adminDashboardService } from '../services/dashboard.service';

export const useAdminDashboard = () => {
  return useQuery({
    queryKey: ['admin-dashboard-kpi'],
    queryFn: () => adminDashboardService.getKpiMetrics(),
    refetchInterval: 5 * 60 * 1000, // Refresh every 5 mins
  });
};
